// extracted by mini-css-extract-plugin
export default {"colsForm":"style_colsForm__IxEyW","cardsProducao":"style_cardsProducao__zHRTC"};